import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Box, Paper, Typography, TextField, Button, Alert, CircularProgress } from '@mui/material';
import apiService from '../services/api';

const AcceptInvite: React.FC = () => {
  const { token } = useParams<{ token: string }>();
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (password.length < 8) { setError('Password must be at least 8 characters.'); return; }
    if (password !== confirm) { setError('Passwords do not match.'); return; }
    setError('');
    setLoading(true);
    try {
      await apiService.acceptInvite(token!, password);
      setSuccess(true);
      setTimeout(() => navigate('/login'), 3000);
    } catch (err: any) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh" bgcolor="#f5f5f5">
      <Paper sx={{ p: 4, width: 400 }}>
        <Typography variant="h5" fontWeight={700} mb={1}>Set Your Password</Typography>
        <Typography variant="body2" color="text.secondary" mb={3}>
          Welcome! Create a password to activate your HRIS account.
        </Typography>

        {success ? (
          <Alert severity="success">
            Password set successfully! Redirecting to login…
          </Alert>
        ) : (
          <form onSubmit={handleSubmit}>
            {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
            <TextField
              fullWidth label="New Password" type="password"
              value={password} onChange={e => setPassword(e.target.value)}
              sx={{ mb: 2 }} required
            />
            <TextField
              fullWidth label="Confirm Password" type="password"
              value={confirm} onChange={e => setConfirm(e.target.value)}
              sx={{ mb: 3 }} required
            />
            <Button
              type="submit" variant="contained" fullWidth size="large"
              disabled={loading}
            >
              {loading ? <CircularProgress size={24} /> : 'Set Password & Login'}
            </Button>
          </form>
        )}
      </Paper>
    </Box>
  );
};

export default AcceptInvite;
